<template>
  <div class="datalink-detail">
    <div class="box">
      {{ details.length }} Items
      <div class="is-pulled-right buttons">
        <a
          ref="csvDownloadLink"
          class="button is-small download-button "
          :download="csvFileName"
          @click="downloadCsv"
        >
          <font-awesome-icon
            class="vs-icon"
            icon="file-download"
          />
          Download CSV
        </a>
        <button
          class="button is-small is-primary"
          :disabled="isSent"
          @click="sendDetails"
        >
          <font-awesome-icon
            class="vs-icon"
            icon="cloud-upload-alt"
          />
          <span v-if="isSent">
            Already Sent
          </span>
          <span v-else>
            Send to Virtusize
          </span>
        </button>
        <button
          class="button is-small button_delete"
          @click="clickDelete"
        >
          Delete
        </button>
      </div>
    </div>
    <vs-table
      :columns="DATALINK_DETAILS"
      :dataArray="details"
      :options="{'hover': true}"
    />
  </div>
</template>

<script>
import WarningModal from '../modal/Warning'
import { mapActions } from 'vuex'
import { DATALINK_DETAILS } from '@/misc/tables'
import CsvHelper from '@/lib/csvHelper'

export default {
  props: {
    details: {
      type: Array,
      required: true
    },
    info: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      DATALINK_DETAILS
    }
  },
  computed: {
    csvFileName () {
      return `${this.info.created}.csv`
    },
    isSent () {
      return !!this.info.sent
    }
  },
  methods: {
    ...mapActions('datalink', [
      'sendToVirtusize', 'deleteHistory'
    ]),
    downloadCsv () {
      const headers = this.DATALINK_DETAILS.map(column => column.label)
      const fields = this.DATALINK_DETAILS.map(column => column.key)
      const dateFormatChanged = this.details.map(history => {
        let newObg = {
          ...history
        }
        const data = {
          ...history.data
        }
        delete newObg.data
        Object.keys(data).forEach(historyKey => {
          newObg[`data.${historyKey}`] = data[historyKey]
        })
        return newObg
      })
      const helper = new CsvHelper(headers)
      this.$refs.csvDownloadLink.href = helper.createFileURL(dateFormatChanged, fields)
    },
    async sendDetails () {
      await this.sendToVirtusize(this.info.created)
    },
    clickDelete () {
      this.$modal.open({
        parent: this,
        component: WarningModal,
        canCancel: ['escape']
      })
    },
    deleteRecord () {
      this.deleteHistory(this.info.created)
      this.$router.push({ name: 'datalink' })
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  margin-right: 1px;
  margin-bottom: 0 !important;
  margin-left: 1px;
  border-radius: 0;
  font-weight: 400;
  font-size: 20px;
}

.button_delete {
  color: $warning;
}
</style>
